"use client";
import { Flex } from "@radix-ui/themes";
import React, { useState, useEffect } from "react";
import axios, { HttpStatusCode } from "axios";
import ImagePanel from "./ImagePanel";
import MainImagePreview from "./MainImagePreview";
import { cn, generateImageUrlFromKey } from "@/lib/utils";
import useSWR from "swr";

interface Props {
  auctionId: string;
  lotId: string;
  className?: string;
}

const LotPageImagePreview = ({ auctionId, lotId, className }: Props) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const { data: images, isLoading } = useSWR(
    `/api/image/auctions/${auctionId}/lots/${lotId}`,
    async (url) => {
      const response = await axios.get(url);
      const data = response.data;
      return data.map((key: string) => ({
        key: key,
        preview: generateImageUrlFromKey(key),
      }));
    },
    {
      refreshInterval: 0,
      fallbackData: [],
    }
  );

  useEffect(() => {
    setCurrentIndex(0);
  }, [lotId])

  return (
    <Flex
      direction="column"
      className={cn("sm:top-12 h-[620px] rounded-md overflow-hidden lg:sticky lg:w-5/12", className)}
    >
      <Flex className="h-[550px] max-sm:h-[480px] w-full relative">
        <MainImagePreview
          loading={isLoading}
          currentIndex={currentIndex}
          images={images}
        />
      </Flex>
      <ImagePanel
        loading={isLoading}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        images={images}
      />
    </Flex>
  );
};

export default LotPageImagePreview;
